const HOST = {
  API_PROD: 'https://api.ihrhelden.de',
  API_DEV: 'https://dev.api.ihrhelden.de',
  WEB_PROD: 'https://ihrhelden.de'
};

export const isProd =
  process.env.NEXT_PUBLIC_API_URI === HOST.API_PROD || false;

export const API_URL = process.env.NEXT_PUBLIC_API_URI || '';

export const WEB_URL = process.env.NEXT_PUBLIC_WEB_URI || '';

export const isProdWeb =
  (process.env.NEXT_PUBLIC_WEB_URI ?? '').replace(/\/+$/, '') === HOST.WEB_PROD;

export const APP_TOKEN = process.env.SERVER_APP_TOKEN || '';

export const GA_ID = process.env.NEXT_PUBLIC_GA_ID || '';

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

export const RECAPTCHA_SITE_KEY =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

// The provider's script tag id; `isRecaptchaTeardownError` checks for it.
export const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v3';

export const LOCALE = process.env.NEXT_PUBLIC_LOCALE || 'en';

// Bump the filename when the image changes; WhatsApp/Meta cache by URL.
export const DEFAULT_OG_IMAGE = {
  url: '/og/ihrhelden-share-v2.jpg',
  width: 1200,
  height: 630,
  alt: 'ihrHelden',
  type: 'image/jpeg'
};
